import React, { memo } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
  useStore,
} from "@xyflow/react";

const compactLabel = (value, maxLength = 20) => {
  const characters = Array.from(String(value || ""));
  return characters.length > maxLength
    ? `${characters.slice(0, maxLength).join("")}…`
    : characters.join("");
};

function StoryTrackEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerStart,
  markerEnd,
  style,
  label,
}) {
  const showLabel = useStore((state) => state.transform[2] >= 0.55);
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 10,
  });
  const visibleLabel = showLabel ? compactLabel(label) : "";

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerStart={markerStart}
        markerEnd={markerEnd}
        style={style}
        interactionWidth={16}
      />
      {visibleLabel ? (
        <EdgeLabelRenderer>
          <div
            className="interactive-story-edge-label nodrag nopan"
            style={{
              "--story-edge-color": style?.stroke,
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            }}
          >
            {visibleLabel}
          </div>
        </EdgeLabelRenderer>
      ) : null}
    </>
  );
}

export default memo(StoryTrackEdge);
